import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  SharedItemMembershipSchema,
  type SharedItemMembership,
} from "@/lib/data/schemas/matters/SharedItemMembershipSchema";
import type { APIResponse } from "@/lib/types";

const relatedObjectPaths = {
  incident: "incidents",
  "incident-report": "incident-reports",
  vehicle: "vehicles",
  insurance: "insurances",
} as const;

export type RelatedMatterObjectType = keyof typeof relatedObjectPaths;

export const retrieveObjectMatterMemberships = async ({
  objectType,
  objectId,
  currentMatterId,
}: {
  objectType: Exclude<RelatedMatterObjectType, "incident">;
  objectId: string;
  currentMatterId: string;
}): Promise<APIResponse<SharedItemMembership>> => {
  const response = await authenticatedFastApiAxiosInstance.get<
    APIResponse<SharedItemMembership>
  >(
    `matters/v2/${relatedObjectPaths[objectType]}/${encodeURIComponent(objectId)}/memberships`,
    { params: { currentMatterId } },
  );

  return {
    ...response.data,
    data: SharedItemMembershipSchema.parse(response.data.data),
  };
};

export const linkObjectToRelatedMatter = async ({
  objectType,
  objectId,
  matterId,
}: {
  objectType: RelatedMatterObjectType;
  objectId: string;
  matterId: string;
}): Promise<void> => {
  await authenticatedFastApiAxiosInstance.post(
    `matters/${objectType === "vehicle" || objectType === "insurance" ? "v4" : "v2"}/${relatedObjectPaths[objectType]}/${encodeURIComponent(objectId)}/link`,
    { matterId },
  );
};

export const unlinkObjectFromMatter = async ({
  objectType,
  objectId,
  matterId,
}: {
  objectType: RelatedMatterObjectType;
  objectId: string;
  matterId: string;
}): Promise<void> => {
  await authenticatedFastApiAxiosInstance.post(
    `matters/v2/${relatedObjectPaths[objectType]}/${encodeURIComponent(objectId)}/unlink`,
    { matterId },
  );
};
